// WebGL 1 / GLSL ES 1.00 so it runs on every phone the shop supports.
// The algorithm is the "no mask" mode of the reference test page: per channel,
// in linear light, a fixed random threshold per grain cell shifted by a
// per-frame phase; the pixel is pushed towards fully on/off by `strength`.
// Averaged over frames the output equals the image (the threshold is uniform
// in [0, 1) and the phase walks it evenly); a single frame keeps the noise.

export const VERTEX_SHADER = `
attribute vec2 a_pos;
varying vec2 v_uv;
void main() {
  // Clip space y = +1 is the top; texture row 0 is the image's top row.
  v_uv = vec2(a_pos.x * 0.5 + 0.5, 0.5 - a_pos.y * 0.5);
  gl_Position = vec4(a_pos, 0.0, 1.0);
}
`;

// highp only: with mediump's ~10-bit mantissa the hash bands into a few
// levels and the time average drifts off the image, so ScreenNoiseRenderer
// refuses such GPUs (the caller then shows the plain image).
export const FRAGMENT_SHADER = `
precision highp float;

uniform sampler2D u_image;
uniform float u_strength;
uniform float u_grain;
uniform float u_phase;
varying vec2 v_uv;

vec3 toLinear(vec3 c) {
  return mix(c / 12.92, pow((c + 0.055) / 1.055, vec3(2.4)), step(0.04045, c));
}

vec3 toSrgb(vec3 c) {
  return mix(c * 12.92, 1.055 * pow(c, vec3(1.0 / 2.4)) - 0.055, step(0.0031308, c));
}

// Three uniform values in [0, 1) per grain cell, one per channel: a stateless
// hash (Dave Hoskins' hash32), so the thresholds stay fixed between frames.
vec3 thresholds(vec2 cell) {
  vec3 p = fract(vec3(cell.xyx) * vec3(0.1031, 0.1030, 0.0973));
  p += dot(p, p.yxz + 33.33);
  return fract((p.xxy + p.yzz) * p.zyx);
}

void main() {
  vec3 value = toLinear(texture2D(u_image, v_uv).rgb);
  vec3 u = fract(thresholds(floor(gl_FragCoord.xy / u_grain)) + u_phase);
  // Strictly value > threshold, as in the reference: with >= a threshold of
  // exactly 0 (cell (0, 0) at phase 0) would lift pure black to grey.
  vec3 bit = 1.0 - step(value, u);
  gl_FragColor = vec4(toSrgb(clamp(value + u_strength * (bit - value), 0.0, 1.0)), 1.0);
}
`;
